module.exports = __webpack_public_path__ + "static/media/social-2.c8763591.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-2.svg
// module id = 1789
// module chunks = 3